<template>
  <div>
    <div class="datamenubox">
      <div
        v-if="getAllMenuCodes.includes('bK2iCPY3')"
        :class="menu == 'assign' ? 'datamenuitem died' : 'datamenuitem'"
        @click="menuchange('assign')"
      >
        农事任务分配
      </div>
      <div
        v-if="getAllMenuCodes.includes('yjKDdVwX')"
        :class="menu == 'history' ? 'datamenuitem died' : 'datamenuitem'"
        @click="menuchange('history')"
      >
        农事任务记录
      </div>
    </div>
    <div class="databox">
      <assign v-if="menu == 'assign'" />
      <history v-if="menu == 'history'" />
    </div>
  </div>
</template>

<script>
import history from "./history.vue";
import assign from "./assign.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    history,
    assign,
  },
  props: {
    defaultTab: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
  },
  data() {
    return {
      menu: "",
    };
  },
  watch: {
    defaultTab(val) {
      if (val && val !== this.menu) {
        this.menu = val;
      }
    },
  },
  created() {
    // 优先使用传入的 defaultTab，如果没有则使用默认逻辑
    if (this.defaultTab && (this.defaultTab === "assign" || this.defaultTab === "history")) {
      // 检查用户是否有对应的权限
      if (this.defaultTab === "assign" && this.getAllMenuCodes.includes("bK2iCPY3")) {
        this.menu = "assign";
      } else if (this.defaultTab === "history" && this.getAllMenuCodes.includes("yjKDdVwX")) {
        this.menu = "history";
      } else {
        // 如果没有权限，则使用默认逻辑
        this.menu = this.getAllMenuCodes.includes("bK2iCPY3")
          ? "assign"
          : this.getAllMenuCodes.includes("yjKDdVwX")
          ? "history"
          : "";
      }
    } else {
      // 没有传入 defaultTab，使用默认逻辑
      this.menu = this.getAllMenuCodes.includes("bK2iCPY3")
        ? "assign"
        : this.getAllMenuCodes.includes("yjKDdVwX")
        ? "history"
        : "";
    }
  },
  methods: {
    menuchange(menu) {
      this.menu = menu;
      this.$emit("tab-change", menu);
    },
  },
};
</script>

<style lang="less" scoped>
.datamenubox {
  margin: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;

  .datamenuitem {
    padding: 10px 20px;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    background-image: url("../../../assets/img/data/btn.png");
    background-size: 100% 100%;
  }

  .died {
    background-image: url("../../../assets/img/data/btned.png");
  }
}
</style>
